export enum ScreenRouteNameEnum {
	list = "screens.list",
	create = "screens.create",
}
